// extracted by mini-css-extract-plugin
export default {"items":"EjkOMk","attachment-name-and-icon":"owViWw"};